
import { Component, HostBinding, OnInit } from '@angular/core'

@Component({
   selector: 'leader-toolkit-dashboard',
   templateUrl: './dashboard-page.component.html',
   styleUrls: ['./dashboard-page.component.scss'],
   standalone: false,
})
export class LeaderToolkitDashboardPage implements OnInit {
  
   ngOnInit(): void {}
  
}
